// A discount may take up to and including this share off the sku's current sell price
const MAX_DISCOUNT_RATIO = 0.5

const withinDiscountLimit = (discount, currentSellPrice) => {
  // Without a current price there is nothing to measure the discount against
  if (!currentSellPrice) return false
  // Compared without dividing, so an exact 50% isn't refused by float rounding
  if (discount.discountPercentage !== null) {
    return Number(discount.discountPercentage) <= MAX_DISCOUNT_RATIO * 100
  }
  return Number(discount.discountAmount) <= currentSellPrice * MAX_DISCOUNT_RATIO
}

module.exports = { MAX_DISCOUNT_RATIO, withinDiscountLimit }
